export default __webpack_public_path__ + "static/media/icon1.e0a60ce1.png";